import React, { useEffect, useState } from 'react';
import { makeStyles } from "@mui/styles";
import { Box, Grid, Button } from '@mui/material';
import FlagstoneTheme from '../../../Config/flagstoneTheme';
import PrintHistoryOverviewTable from './PrintHistoryOverviewTable';
import { useNavigate } from 'react-router-dom';
import { dataService } from '../../../Services/data/data.service'
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { ListFilter, X } from 'lucide-react';
import EventHistoryOverviewTable from './EventHistoryOverviewTable';


export const HistoryPage = (props) => {
    const classes = useStyles();
    const [printHistory, setPrintHistory] = useState([]);
    const [eventHistory, setEventHistory] = useState([]);
    const [showFilters, setShowFilters] = useState(false);
    const [checkpoints, setCheckpoints] = useState([]);
    const [selectedTab, setSelectedTab] = useState("Print history");

    const { t } = useTranslation();
    let navigate = useNavigate();

    const handleFilter = () => {
        setShowFilters(!showFilters);
    }

    // Get print history
    useEffect(() => {
        dataService.getPrintHistory().then((response) => {
            if (response.ok) {
                setPrintHistory(response.data.Results);
            } else {
                toast.error(t("Error getting print history"), { position: "top-center" });
            }
        })
    }, []);

    // Get event history
    useEffect(() => {
        dataService.getEventHistory().then((response) => {
            if (response.ok) {
                setEventHistory(response.data.Results);
            } else {
                toast.error(t("Error getting event history"), { position: "top-center" });
            }
        })
    }, []);

    useEffect(() => {
        dataService.getAllWorkstations().then(result => {
            if (result.ok) {
                var stations = result.data.Results;
                setCheckpoints(stations);
            }
        });
    }, []);

    const handleTabSelection = (tab) => {
        setShowFilters(false);
        setSelectedTab(tab);
    }

    return (
        <div className={classes.container}>
            <div className={classes.header}>
                <h1 className={classes.header__title}>
                    {t(selectedTab)}
                </h1>
                <div className={classes.header__tabSlider}>
                    <button onClick={() => handleTabSelection("Print history")} className={classes.header__tabSliderTab} style={{ color: selectedTab == "Print history" ? "#F8F8F8" : "#0C0E29" }}>{t("Print history")}</button>
                    <button onClick={() => handleTabSelection("Event history")} className={classes.header__tabSliderTab} style={{ color: selectedTab == "Event history" ? "#F8F8F8" : "#0C0E29" }}>{t("Event history")}</button>
                    <div style={{ transform: selectedTab == "Print history" ? "translateX(0px)" : "translateX(144px)" }} className={classes.header__tabSliderIndicator} />
                </div>
                <Button className={classes.header__button} onClick={() => handleFilter()}>
                    {showFilters ?
                        <X size={24} />
                        :
                        <ListFilter size={24} />
                    }
                    {t("Filter")}
                </Button>
            </div>

            <div className={classes.tableContainer}>
                {selectedTab == "Print history" ?
                    <PrintHistoryOverviewTable loading={props.loading} handleLoading={props.handleLoading} printHistory={printHistory} showFilters={showFilters} checkpoints={checkpoints}></PrintHistoryOverviewTable>
                    :
                    <EventHistoryOverviewTable loading={props.loading} handleLoading={props.handleLoading} eventHistory={eventHistory} showFilters={showFilters} checkpoints={checkpoints}></EventHistoryOverviewTable>
                }
            </div>

        </div>
    )
}

const useStyles = makeStyles({
    container: {
        width: '100%',
        position: "relative",
        paddingBottom: "80px",
    },

    header: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",

        position: "relative",

        marginTop: "32px",
        padding: "0px 24px",
    },

    header__title: {
        fontSize: "32px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'normal',

        color: "#0C0E29",

        margin: "0px",
    },

    header__tabSlider: {
        display: "flex",
        backgroundColor: "#F8F8F8",
        borderRadius: "6px",

        position: "absolute",
        left: "50%",
        transform: "translateX(-50%)",
    },

    header__tabSliderIndicator: {
        width: "144px",
        height: "40px",
        borderRadius: "6px",
        backgroundColor: "#4654FB",

        position: "absolute",
        transition: "transform 0.3s",
    },

    header__tabSliderTab: {
        width: "144px",
        height: "40px",

        fontSize: "16px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'normal',
        backgroundColor: "transparent",
        border: "none",
        borderRadius: "6px",
        cursor: "pointer",
        padding: "0px",
        margin: "0px",

        zIndex: "1",

        "&:hover": {
            color: "#4654FB",
        },

        "&.active": {
            color: "#F8F8F8",

            "&:hover": {
                color: "#F8F8F8",
            },
        }
    },

    header__button: {
        color: FlagstoneTheme.palette.primary.main + " !important",
        fontSize: "16px !important",
        fontWeight: "bold !important",
        fontFamily: "Lato, sans-serif !important",
        backgroundColor: "transparent !important",
        border: "1px solid " + FlagstoneTheme.palette.primary.main + " !important",
        minWidth: "fit-content !important",
        height: '40px !important',
        padding: '0px 20px !important',
        paddingLeft: '8px !important',
        textTransform: 'capitalize !important',

        display: 'flex !important',
        justifyContent: 'center !important',
        alignItems: 'center !important',
        gap: '8px !important',

        '&:hover': {
            backgroundColor: FlagstoneTheme.palette.primary.main + " !important",
            color: "white !important",
            border: "1px solid " + FlagstoneTheme.palette.primary.main + " !important",
        },
        '&:disabled': {
            backgroundColor: "lightgrey !important",
            color: "white !important",
            border: "1px solid darkgrey !important",
            cursor: "not-allowed !important"
        },
    },

    tableContainer: {
        marginTop: "24px",
        padding: "0px 24px",
    },

    gridContainer: {
        width: '100%',
        marginRight: "0px !important",
        marginLeft: "0px !important"
    },
    navButton: {
        textDecoration: 'none'
    },

    buttonContainer: {
        textAlign: "center",
    },
});

function mapStateToProps(state) {
    return {
        workstation: state.workstation,
        general: state.general,
        user: state.user
    }
}

export default connect(mapStateToProps)(HistoryPage)